import React from 'react'
import BrandEdit from "./BrandEdit";
import BrandDelete from "./BrandDelete";


const BrandActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <BrandEdit  brand={record} updater={updater} />
            <BrandDelete  brand={record} updater={updater} />
        </React.Fragment>
    )
}
export default BrandActions